import { Message } from './../../../models/centre/message.model';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationExtras } from '@angular/router';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { Utility } from '../../../common/utility';
import { DialogService } from '../../../shared/services/dialog.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { AppMessages } from '../../../shared/constants/messages';
import { ValidationService } from '../../../shared/services/validation.service';
import { ModifyPatientPopupComponent } from '../../centre/manage-patient-user/modify-patient-popup.component';
import { SearchPatientService } from './search-patient.service';

@Component({
  selector: 'search-patient',
  templateUrl: 'search-patient.component.html',
  providers: [SearchPatientService]
})
export class SearchPatientComponent implements OnInit {
  public searchPatientForm: FormGroup;
  public genderData: any[];
  public partyData: any[];

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private searchPatientService: SearchPatientService,
    public utility: Utility,
    public dialogService: DialogService) {
    this.createForm();
  }

  ngOnInit() {
    this.genderData = this.searchPatientService.getListGender();
    this.searchPatientService.getListParty().subscribe(
      (result) => {
        if (result) {
          this.partyData = result.json();
        }
      }
    );
  }

  createForm() {
    const dayOfBirth = this.utility.getDefaultDateOfBirth();
    this.searchPatientForm = this.formBuilder.group({
      reference: '',
      name: ['', [ValidationService.isValidMinLength]],
      userName: ['', [ValidationService.isValidMinLength]],
      address: ['', [ValidationService.isValidMinLength]],
      email: ['', [ValidationService.isValidEmail, ValidationService.isValidMinLength]],
      dateOfBirth: [null, [ValidationService.isValidDateOfBirth]],
      genderId: null,
      organizationId: null
    });
  }

  isValidData() {
    // When no criteria is defined, display error message “Please enter at least one search criteria.”
    if (this.searchPatientForm.controls['reference'].value === '' &&
    this.searchPatientForm.controls['name'].value === '' &&
    this.searchPatientForm.controls['userName'].value === '' &&
    this.searchPatientForm.controls['address'].value === '' &&
    this.searchPatientForm.controls['email'].value === '' &&
    this.searchPatientForm.controls['dateOfBirth'].value === null &&
    this.searchPatientForm.controls['genderId'].value === null &&
    this.searchPatientForm.controls['organizationId'].value === null) {
      this.dialogService.openErrorDialog({message: AppMessages.consultant.errorSearch});
      return false;
    }
    return true;
  }

  onSubmit() {
    if (this.searchPatientForm.valid) {
      if (this.isValidData()) {
        let dateOfBirth = null;
        if ( this.searchPatientForm.controls['dateOfBirth'].value !== null) {
          const date = new Date(this.searchPatientForm.controls['dateOfBirth'].value);
          dateOfBirth = this.utility.convertDateToString(date);
        }
        this.router.navigate(['/consultation/result-search-patient'],
          {
            queryParams:
            {
              reference: this.searchPatientForm.value.reference,
              name: this.searchPatientForm.value.name,
              userName: this.searchPatientForm.value.userName,
              address: this.searchPatientForm.value.address,
              email: this.searchPatientForm.value.email,
              dateOfBirth: dateOfBirth,
              genderId: this.searchPatientForm.value.genderId,
              organizationId: this.searchPatientForm.value.organizationId
            }
          });
      }
    }
  }

  onAddPatientAccount(): void {
    this.dialogService.openComponentDialog(ModifyPatientPopupComponent,
      {},
      { width: '80%' });
  }

  onDateOfBirthChange(event) {
    // ValidationService.validationDate(this.searchPatientForm.controls['dateOfBirth'], event);
  }

  onResetForm() {
    this.createForm();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/search-patient/search-patient.component.ts